/**
 * Sai do app para um endereço de fora. Só o consentimento OAuth usa: depois de "Conectar" ou
 * "Agora não", o navegador volta ao cliente MCP pelo endereço que o Supabase Auth devolve
 * (docs/api/mcp.md, passo 7). Fica num módulo só para os testes trocarem.
 */
export function leaveTo(url: string) {
  window.location.assign(url)
}
